// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27oqR","badges":"styles_badges__apjh3"};